<template>
	<div class="grow flex flex-col gap-4 md:gap-8 items-center justify-center text-center text-gray-400 overflow-y-auto">
		<i class="fa-solid fa-spinner animate-spin text-[64px] md:text-[128px] lg:text-[192px]"/>
		<p class="text-3xl md:text-5xl font-thin">{{ trans('general.loading') }}</p>
	</div>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
</script>